import './js/src/functions';
import './js/src/modules';
import './js/src/header';
import './js/src/forms';

document.addEventListener('DOMContentLoaded', () => {
  global.modules.init();
});

// css
import './css/common.css';
import './components/estimate_hero.css';
import './components/contact_info.css';
import './components/contacts.css';
import './components/map.css';
import './components/mini_contacts.css';